import { createContext, useContext } from 'react';
import { WorkflowHeaderTitle, WorkflowHeaderTitleWithOverview } from './WorkflowHeader';
import type { WorkflowOverviewStore } from './workflowOverviewStore';

export interface WorkflowSession {
  parentTitle: string;
  requestClose: () => void;
}

export function createWorkflowSession(defaultClose: () => void, parentTitle: string): WorkflowSession {
  return {
    parentTitle,
    requestClose: defaultClose,
  };
}

const WorkflowSessionContext = createContext<WorkflowSession | undefined>(undefined);

export const WorkflowSessionProvider = WorkflowSessionContext.Provider;

export function useWorkflowSession(): WorkflowSession | undefined {
  return useContext(WorkflowSessionContext);
}

export function WorkflowSessionHeaderTitle({
  fallbackTitle,
  overviewStore,
}: {
  fallbackTitle: string;
  overviewStore?: WorkflowOverviewStore;
}) {
  if (overviewStore) {
    return <WorkflowHeaderTitleWithOverview title={fallbackTitle} store={overviewStore} />;
  }
  return <WorkflowHeaderTitle title={fallbackTitle} />;
}
